import { WarehouseResult } from '@models/address.model';

export function getWarehouseDescription(warehouse: WarehouseResult): string {
  return warehouse?.Description;
}
